import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { useStore } from "vuex";
import { useRoute } from "vue-router";
import AccountLoader from "./components/AccountLoader.vue";
import HomeView from "@/views/HomeView.vue";
import { onMounted } from "vue";
import { State } from "@/store";
import { OptionsSetting } from "@/store/options";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();
const store = useStore();
const state = store.state as State;

onMounted(async () => {
    const el = document.querySelector("html");
    if (el && state.options[OptionsSetting.DarkMode] === "on") {
        el.setAttribute("data-theme", "dark");
    }
});

return (_ctx: any,_cache: any) => {
  return (_unref(route).params.accountInput)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(AccountLoader, {
          accountInput: _unref(route).params.accountInput || ''
        }, null, 8, ["accountInput"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(HomeView)
      ]))
}
}

})